import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { ApiErrorHandlerProvider } from "../api-error-handler/api-error-handler";
import moment from 'moment';

@Injectable()
export class TeamServiceProvider {

  public shopId: number;
  public shopName: string;
  public isRefresh = new BehaviorSubject(false);

  constructor(
    public http: HttpClient,
    private apiErrorHandler: ApiErrorHandlerProvider,
  ) {
    this.shopId = null;
    this.shopName = null;
  }

  getShop(teamId) {
    return new Promise((resolve, reject) => {
      this.http.get(`/teams/${teamId}`).subscribe(
        (shop: any) => {
          resolve(shop);
        },
        (error) => {
          this.apiErrorHandler.handleError(error);
          reject(error);
        },
        () => {
        },
      );
    });
  }

  getOpeningHours(teamId) {
    return new Promise((resolve, reject) => {
      this.http.get(`/teams/${teamId}/opening-hours`).subscribe(
        (openingHours: any) => {
          resolve(openingHours);
        },
        (error) => {
          this.apiErrorHandler.handleError(error);
          reject(error);
        },
        () => {
        },
      );
    });
  }

  getShopLocations(shopId: any = null) {

    if (!shopId) {
      shopId = this.shopId;
    }

    return new Promise((resolve, reject) => {
      this.http.get(`/teams/${shopId}/locations`).subscribe(
        (shops: any) => {
          resolve(shops);
        },
        (error) => {
          this.apiErrorHandler.handleError(error);
          reject(error);
        },
        () => {
        },
      );
    });
  }

  isShopIdInShopLocations(shopId: any) {
    return new Promise(resolve => {
      let locationShopIds = [];
      this.getShopLocations(this.shopId).then((shops: any) => {
        shops.forEach(shop => {
          locationShopIds.push(parseInt(shop.id));
        });
        if (locationShopIds.indexOf(shopId) >= 0) {
          resolve(true);
        } else {
          resolve(false);
        }
      });
    });
  }

  getShopLocationIds() {
    return new Promise(resolve => {
      let locationShopIds = [];
      this.getShopLocations(this.shopId).then((shops: any) => {
        shops.forEach(shop => {
          locationShopIds.push(parseInt(shop.id));
        });
        return resolve(locationShopIds);
      });
    });
  }

  isCustomApp() {
    if (localStorage.getItem('isCustomApp')) return true;
    if (this.shopId) {
      localStorage.setItem('isCustomApp', 'true');
      return true;
    }

    return false;
  }


  filterAvailableUsers(shop) {
    return new Promise(resolve => {
      let filteredUsers = [];
      for (var i = 0; i < shop.users.length; i++) {
        let user = shop.users[i];
        let todayAdvanceBookings = [];
        // Remove user if user has holiday today
        if (user.holidays.holidayToday === true) {
          continue;
        }

        // Remove user if user is not checked in at the current team
        if (!user.current_active_team || user.current_active_team !== shop.id) {
          continue;
        }
        if (user.today_advanced_bookings && user.today_advanced_bookings.length > 0) {
          user.today_advanced_bookings = user.today_advanced_bookings.filter(res => res.requested_booking_time && res.estimated_booking_time == null);
        }

        filteredUsers.push(user);
      }
      shop.users = filteredUsers;
      return resolve(shop);
    });
  }

  getHolidays(shop) {
    return new Promise((resolve, reject) => {
      this.http.get(`/teams/${shop.id}/staff-holiday`)
        .subscribe(holidays => {
          if (shop.users) {
            shop.users.forEach((user, index) => {
              shop.users[index].holidays = [];
              if (holidays[user.id]) {
                shop.users[index].holidays = holidays[user.id];
              }
            });
          }
          return resolve(shop);
        }, error => {
          // this.errors = this.apiErrorHandler.handleError(error);
          return reject(error);
        }, () => {
          // this.loading = false;
        });
    });
  }


}



// WEBPACK FOOTER //
// ./src/providers/team-service/team-service.ts